import { ErrorResponseErrorItemCodeLicense } from '../../../../typings/api/skymap/rest/v1/.common';

export const translations: Record<ErrorResponseErrorItemCodeLicense, string> = {
  'license:missing_design_tool_access': 'Du saknar rättigheter för Design.',
  'license:access_denied': 'Du har inte åtkomst till licensen.',
  'license:access_denied_to_remove_subscription':
    'Du har inte rättighet att ta bort prenumerationen från licensen.',
  'license:not_found': 'Licensen kunde ej hittas.',
  'license:subscription_is_already_active': 'Licensen har redan köpts.',
  'license:license_of_type_already_exists': 'En licens existerar redan. Kontakta SkyMap support.',
  'license:user_has_no_valid_license_for_company': 'Du saknar giltig licens till aktuellt företag.',
};
